var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM15.5656 13.3788C16.2299 13.917 16.96 14.2476 17.74 14.2476C18.7903 14.2476 19.6472 13.3891 19.6504 12.338C19.6504 11.2837 18.7935 10.4252 17.74 10.4252C16.3353 10.4252 15.8788 11.7831 15.7345 12.5916L15.7273 12.6194L15.5656 13.3788ZM13.989 11.5746C14.5542 9.65469 15.9453 8.48705 17.74 8.48705C19.8581 8.48705 21.5822 10.2135 21.5838 12.33C21.5838 14.4505 19.8597 16.1881 17.7416 16.1881C16.7507 16.1881 15.8867 15.886 15.1352 15.4041L14.2783 19.4444H12.3005L13.484 13.8742C12.9252 13.1703 12.4654 12.3792 12.0897 11.5952V12.4394C12.0897 14.5004 10.4139 16.192 8.3561 16.192C6.29827 16.192 4.62252 14.5004 4.62965 12.4394V7.40741H6.56144V12.4394C6.56144 13.4311 7.36841 14.2396 8.35927 14.2396C9.35014 14.2396 10.1579 13.4311 10.1579 12.4394V7.40741H12.0889C12.4718 8.71931 13.1249 10.277 13.989 11.5746Z",
    fill: "#081538"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.742fdd503d5145c4bf60b9f5f439763f.svg";
export { ForwardRef as ReactComponent };